export default "__VITE_ASSET__BVi$Ymac__"